import { render, staticRenderFns } from "./behaviorRule.vue?vue&type=template&id=7a7dd09e&scoped=true"
import script from "./behaviorRule.vue?vue&type=script&lang=js"
export * from "./behaviorRule.vue?vue&type=script&lang=js"
import style0 from "./behaviorRule.vue?vue&type=style&index=0&id=7a7dd09e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7dd09e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a7dd09e')) {
      api.createRecord('7a7dd09e', component.options)
    } else {
      api.reload('7a7dd09e', component.options)
    }
    module.hot.accept("./behaviorRule.vue?vue&type=template&id=7a7dd09e&scoped=true", function () {
      api.rerender('7a7dd09e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newLabelManagement/labelManagement/components/behaviorRule.vue"
export default component.exports